import { Box, Link } from '@mui/material';
import { teal } from "@mui/material/colors";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';

const DeploymentStatus = ({ status, deploymentId, onViewVehiclesClick }) => {
    let background = teal[700];
    let colors = {
        "COMPLETED": "#3ba272",
        "PUBLISHED": "#5470c6",
        "SCHEDULED": "#73c0de",
        "PUBLISH_IN_PROGRESS":"#586413",
        "NOT_PUBLISHED": "#fc8452",
        "EXPIRED": "#f44336",
        "CANCELED": "#ee6666"
    };

    let color = colors[status] || background;
    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
            <Box sx={{ height: '20px', width: "130px", textAlign: 'center', display: "inline", fontSize: 10, background: color, borderRadius: '5px', color: 'white', padding: "4px 7px", fontWeight: 'bold' }}>
                {status.replace(/_/g, " ")}
            </Box>
            {deploymentId ? (
                <Link
                    component={RouterLink}
                    to={`/deployments/${deploymentId}/vehicles`}
                    onClick={onViewVehiclesClick}
                    underline="none"
                    sx={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 0.5,
                        fontSize: 12,
                        fontWeight: 600,
                    }}
                >
                    View Vehicles
                    <ArrowForwardRoundedIcon fontSize="small" />
                </Link>
            ) : null}
        </Box>
    )
}

export default DeploymentStatus;